export const branding = {
  productName: 'Cabal',
  wordmark: 'Cabal',
  logoPath: '/brand/porxima_favicon_caballo_512.png',
  auth: {
    logoPath: '/brand/horse-led-logo.png',
    providerStatus: 'Secured by Cabal',
  },
  workspace: {
    logoPath: '/brand/porxima_favicon_caballo_512.png',
    iconBasePath: '/reference/icons',
    solanaLogoPath: '/reference/solana.png',
    marketLogos: ['/reference/pumpfun.png', '/reference/bonkfun.png', '/reference/bags.png'],
  },
  referral: {
    bannerPath: '/reference/referral-banner.webp',
    texturePath: '/reference/referral-moire.svg',
    artwork: {
      cashback: {
        back: '/reference/rewards/cashback-back.webp',
        front: '/reference/rewards/cashback-front.webp',
      },
      referral: {
        back: '/reference/rewards/referral-back.webp',
        front: '/reference/rewards/referral-front.webp',
      },
    },
    displayHost: 'blastgit.fun',
  },
  dashboardPreviewPath: '/brand/dashboard-preview.png',
  storyArtwork: {
    wallets: '/brand/feature-0.png',
    trading: '/brand/feature-2.png',
  },
  docsUrl: 'https://docs.proxima.tools/',
  appUrl: '/workspace',
  social: {
    x: 'https://x.com/joinproxima',
    telegram: 'https://t.me/+-ooWNd7PcYRiMGQ0',
  },
};
